// @flow
import React, { Component } from "react";
import Highlighter from "react-highlight-words";
import moment from "moment";
import { Status, Button, LocaleLink } from "../../../common/";
import I18n from "../../../../i18n/I18n";
import Helper from "../../../../helper/Helper";
import styles from "../../../orders/orderTable/orderBox/OrderBox.scss";

class ProductRowBox extends Component {
  state = { isPaneOpen: false };

  openModal = () => {
    this.setState({
      isPaneOpen: true
    });
  };
  onCloseModal = () => {
    this.setState({
      isPaneOpen: false
    });
  };

  render() {
    const { item, searchString, property, seller } = this.props;

    return (
      <LocaleLink
        to={`/disputes/ticket/${item.ticket_nr}`}
        className={styles.backArrow}
      >
        <div className={styles.ctr}>
          <div className={styles.flexer}>
            <Button variant="asn" className={styles.asnBtn}>
              <div>{item.ticket_nr}</div>
            </Button>
            <div className={styles.statusCtr}>
              <Status status={item.status} />
            </div>
          </div>
          <div className={styles.descCtr}>
            <div className={styles.attrCtr}>
              {item.dispute_type ? (
                <div className={styles.eachAttr}>
                  <h6 className={styles.attrTitle}>
                    {I18n.getText("disputes.dispute-type")}
                  </h6>
                  <div className={styles.attrVal}>{item.dispute_type}</div>
                </div>
              ) : (
                ""
              )}
              {item.ref_to ? (
                <div className={styles.eachAttr}>
                  <h6 className={styles.attrTitle}>
                    {I18n.getText("disputes.doc-nr")}
                  </h6>
                  <div className={styles.attrVal}>
                    <Highlighter
                      highlightClassName={styles.highlight}
                      searchWords={[searchString]}
                      autoEscape={true}
                      textToHighlight={item.ref_to}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
              {item.created_at ? (
                <div className={styles.eachAttr}>
                  <h6 className={styles.attrTitle}>
                    {I18n.getText("statement-details.order-view-created")}
                  </h6>
                  <div className={styles.attrVal}>
                    {item && item.created_at
                      ? moment(item.created_at).format(`YYYY-MM-DD`)
                      : "-"}
                  </div>
                </div>
              ) : (
                ""
              )}
              {item.closed_at ? (
                <div className={styles.eachAttr}>
                  <h6 className={styles.attrTitle}>
                    {I18n.getText("transfers.closed-at")}
                  </h6>
                  <div className={styles.attrVal}>{item.warehouse_name}</div>
                </div>
              ) : (
                ""
              )}
              <div className={styles.eachAttr}>
                <h6 className={styles.attrTitle}>
                  {I18n.getText("disputes.paid")}
                </h6>
                <div className={styles.attrVal}>
                  {item.resolution_amount
                    ? I18n.formatCurrency(
                        Helper.formatPrice(
                          item.resolution_amount,
                          item.currency
                        )
                      )
                    : I18n.getText("disputes.unpaid")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </LocaleLink>
    );
  }
}
export default ProductRowBox;



// WEBPACK FOOTER //
// ./src/components/disputes/disputesTable/disputesRowBox/DisputesRowBox.js